import { Stack, styled } from '@mui/material';

export const EntityWindowWrapper = styled(Stack, {
  name: 'EntityWindowWrapper',
})(({ theme }) => ({
  height: '100%',
  flex: 1,
  flexDirection: 'row',
  backgroundColor: theme.palette.custom.OV.sys.surfaceContainerLowest,
  zIndex: theme.zIndex.app.ServiceDeskConversation,
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
  },
}));
